import { render, staticRenderFns } from "./bac-member.vue?vue&type=template&id=4bd13286&"
import script from "./bac-member.vue?vue&type=script&lang=js&"
export * from "./bac-member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports